"use client";

import Link from "next/link";

/**
 * Inline unlock card shown over the blurred table/filters when the visitor
 * has no account. NOT a modal — the page (title, SEO copy, teaser rows)
 * stays visible and scrollable; only the live data is gated.
 */
export default function UnlockOverlay({
  title,
  subtitle,
  bullets,
}: {
  title: string;
  subtitle: string;
  bullets: string[];
}) {
  return (
    <div
      style={{
        position: "absolute",
        inset: 0,
        zIndex: 20,
        display: "flex",
        alignItems: "flex-start",
        justifyContent: "center",
        paddingTop: "16vh",
        pointerEvents: "none",
      }}
    >
      <div
        style={{
          pointerEvents: "auto",
          background: "rgba(0,0,0,0.92)",
          border: "1px solid rgba(255,255,255,0.18)",
          borderRadius: 12,
          padding: "28px 32px",
          maxWidth: 440,
          margin: "0 16px",
          boxShadow: "0 24px 80px rgba(0,0,0,0.9)",
          textAlign: "center",
        }}
      >
        <div
          style={{
            fontSize: 10,
            fontWeight: 800,
            letterSpacing: 2,
            color: "#10b981",
            textTransform: "uppercase",
            marginBottom: 10,
          }}
        >
          Free with an account
        </div>
        <h2 style={{ margin: 0, fontSize: 20, fontWeight: 700, color: "#f4f4f5", letterSpacing: 0.2 }}>
          {title}
        </h2>
        <p style={{ margin: "10px 0 16px", fontSize: 13, lineHeight: 1.55, color: "rgba(255,255,255,0.82)" }}>
          {subtitle}
        </p>
        <ul style={{ listStyle: "none", padding: 0, margin: "0 0 20px", textAlign: "left" }}>
          {bullets.map((b) => (
            <li
              key={b}
              style={{
                display: "flex",
                gap: 8,
                alignItems: "baseline",
                fontSize: 12.5,
                color: "rgba(255,255,255,0.85)",
                padding: "3px 0",
              }}
            >
              <span style={{ color: "#10b981", fontWeight: 700 }}>✓</span>
              {b}
            </li>
          ))}
        </ul>
        <Link
          href="/signup"
          style={{
            display: "block",
            background: "#10b981",
            color: "#000",
            fontWeight: 700,
            fontSize: 14,
            padding: "11px 0",
            borderRadius: 7,
            textDecoration: "none",
          }}
        >
          Create your free account
        </Link>
        <div style={{ marginTop: 10, fontSize: 12, color: "rgba(255,255,255,0.78)" }}>
          No credit card required ·{" "}
          <Link href="/login" style={{ color: "#f4f4f5", textDecoration: "underline" }}>
            Sign in
          </Link>
        </div>
      </div>
    </div>
  );
}
